import { stringifyUnknown } from "./stringifyUnknown";

/**
 * Coerce an unknown thrown/caught value into an `Error`.
 *
 * `catch` bindings and resolve-with-error paths are typed `unknown`; this narrows them to a real
 * `Error` while preserving the original value as `cause` (so a non-`Error` throw isn't discarded).
 * Prefer this over the inline `x instanceof Error ? x : new Error(String(x))` idiom.
 * When you need a serializable summary for logging rather than an `Error`, use `summarizeErrorCause`.
 */
export function coerceError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  return new Error(stringifyUnknown(error), { cause: error });
}
